import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateModelDescriptionIris =
  (prevIri: string, newIri: string) => (model: Model) => {
    const descriptionsByIri = Object.entries(
      model.modelData.descriptionsByIri
    ).reduce<Record<string, string>>(
      (acc, [prevDescriptionIri, prevDescription]) => {
        const descriptionIri =
          prevDescriptionIri === prevIri ? newIri : prevDescriptionIri;
        acc[descriptionIri] = prevDescription;
        return acc;
      },
      {}
    );
    setDataProperty<ModelData>(model)(
      model.modelData,
      'descriptionsByIri',
      descriptionsByIri
    );
  };
